import { PageHeader } from '@platform/design-system';
import type { ShippingClient } from '@platform/openapi';
import { usePageContext } from '../usePageContext.ts';
import { HandoverSession } from './HandoverSession.tsx';
import type { HandoverFilters } from './handover.ts';
import { HandoverStart } from './HandoverStart.tsx';

export type HandoverPageProps = {
  shipping: ShippingClient;
  handoverId: string | null;
  filters: HandoverFilters;
  onFiltersChange: (filters: HandoverFilters) => void;
  onOpenHandover: (handoverId: string | null) => void;
};

export const HandoverPage = ({
  shipping,
  handoverId,
  filters,
  onFiltersChange,
  onOpenHandover,
}: HandoverPageProps) => {
  const { t } = usePageContext();
  return (
    <>
      <PageHeader title={t('nav.handover')} context={t('handover.context')} />
      {handoverId === null ? (
        <HandoverStart
          shipping={shipping}
          filters={filters}
          onFiltersChange={onFiltersChange}
          onOpenHandover={onOpenHandover}
        />
      ) : (
        <HandoverSession
          shipping={shipping}
          handoverId={handoverId}
          onBack={() => {
            onOpenHandover(null);
          }}
        />
      )}
    </>
  );
};
